import React, { useContext } from 'react';
import { Navbar, Nav, Dropdown } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import ApplicationContext from '../contexts/ApplicationContext';
import AuthContext from '../contexts/AuthContext';

const Navigation = () => {
  const { currentApplication, setCurrentApplication, applications } = useContext(ApplicationContext);
  const { user, logout } = useContext(AuthContext);
  const location = useLocation();

  const handleApplicationChange = (app) => {
    setCurrentApplication(app);
  };

  return (
    <Navbar bg="light" expand="lg" className="shadow-sm">
      <div className="container-fluid">
        <Navbar.Brand as={Link} to="/">
          <i className="fas fa-ticket-alt me-2"></i>
          Help Desk
          {currentApplication && (
            <span className="badge ms-2" style={{ backgroundColor: currentApplication.primary_color }}>
              {currentApplication.name}
            </span>
          )}
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link 
              as={Link} 
              to="/" 
              className={location.pathname === '/' ? 'active' : ''}
            >
              <i className="fas fa-tachometer-alt me-1"></i>
              Dashboard
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/tickets"
              className={location.pathname.startsWith('/tickets') ? 'active' : ''}
            >
              <i className="fas fa-list me-1"></i>
              Tickets
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/review-queue"
              className={location.pathname === '/review-queue' ? 'active' : ''}
            >
              <i className="fas fa-inbox me-1"></i>
              Review Queue
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/knowledge-base"
              className={location.pathname === '/knowledge-base' ? 'active' : ''}
            >
              <i className="fas fa-book me-1"></i>
              Knowledge Base
            </Nav.Link>
          </Nav>

          <Nav>
            <Dropdown align="end" className="me-2">
              <Dropdown.Toggle variant="outline-secondary" id="staff-dropdown">
                <i className="fas fa-user-shield me-1"></i>
                {user?.first_name || user?.username || 'Staff'}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Header>Signed in</Dropdown.Header>
                <Dropdown.ItemText>
                  <div className="fw-semibold">{user?.username}</div>
                  {user?.helpdesk_application_user?.name && (
                    <small className="text-muted">{user.helpdesk_application_user.name}</small>
                  )}
                </Dropdown.ItemText>
                <Dropdown.Divider />
                <Dropdown.Item onClick={logout}>
                  <i className="fas fa-right-from-bracket me-2"></i>
                  Sign Out
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            <Dropdown align="end">
              <Dropdown.Toggle variant="outline-secondary" id="application-dropdown">
                <i className="fas fa-apps me-1"></i>
                {currentApplication ? currentApplication.name : 'Select Application'}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Header>Switch Application</Dropdown.Header>
                {applications.map((app) => (
                  <Dropdown.Item
                    key={app.id}
                    onClick={() => handleApplicationChange(app)}
                    active={currentApplication?.id === app.id}
                  >
                    <div className="d-flex align-items-center">
                      <div 
                        className="rounded me-2" 
                        style={{ 
                          width: '12px', 
                          height: '12px', 
                          backgroundColor: app.primary_color 
                        }}
                      ></div>
                      {app.name}
                    </div>
                    <small className="text-muted">{app.domain}</small>
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </Nav>
        </Navbar.Collapse>
      </div>
    </Navbar>
  );
};

export default Navigation;
